module.exports = __webpack_public_path__ + "img/popup_tus_envios_vuelan.b352db94.png";